import React from "react";
import { Calendar } from "primereact/calendar";
import { InputIcon } from "primereact/inputicon";
import { StyledIconField } from "./CustomInput.styles";

interface CustomCalendarProps {
  value: Date | Date[] | null;
  setValue: (value: Date | Date[] | null) => void;
  onBlur?: () => void;
  placeholder?: string;
  icon: React.ReactNode;
  iconPosition?: "left" | "right";
  invalid?: boolean;
  showTime?: boolean;
  dateFormat?: string;
  selectionMode?: "single" | "range" | "multiple";
}

const CustomCalendar: React.FC<CustomCalendarProps> = ({
  value,
  setValue,
  onBlur,
  placeholder,
  icon,
  iconPosition = "left",
  invalid,
  showTime = false,
  dateFormat = "dd.mm.yy",
  selectionMode = "single",
}) => {
  const handleChange = (e: any) => {
    setValue(e.value);
  };

  return (
    <StyledIconField iconPosition={iconPosition}>
      <InputIcon>{icon}</InputIcon>
      <Calendar
        className="w-full"
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder || "Выберите дату"}
        showTime={showTime}
        dateFormat={dateFormat}
        selectionMode={selectionMode}
        invalid={invalid}
      />
    </StyledIconField>
  );
};

export default CustomCalendar;
